<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Ambientes" >
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Ambiente</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
          
            <b-col cols="auto">
                <b-form-group>
                    <label for="name" style="font-size: 0.8em">Filtro</label>
                    <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                </b-form-group>
            </b-col>
        
          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                      <b-row v-if="row.item.description">
                            <b-col>Descrição: <b>{{ row.item.description }}</b></b-col>
                        </b-row>
  
                    </b-card>
                </template>
                                        
                <template v-slot:cell(scheduleStopStart)="data">
                    {{ $utils.localDateTime( data.item.scheduleStopStart ) }}
                </template>

                <template v-slot:cell(scheduleStopEnd)="data">
                    {{ $utils.localDateTime( data.item.scheduleStopEnd ) }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(action)="data">
                      <b-button size="sm" variant="dropbox" @click="openScheduleStop(data.item)" class="mr-1 btn-brand" title="Parada Programada" style="margin-bottom: 4px">
                      <i class="fa fa-refresh"></i></b-button>
                </template>
                
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Ambiente"
              size="lg">
  
        <b-card>
            <b-form @submit.stop.prevent="onSubmit">
    
                <div class="animated fadeIn">
            
                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Código"
                            label-for="code"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input v-model="selectedItem.code" id="code" type="number" ></b-form-input>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Ambiente"
                            label-for="name"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input v-model="selectedItem.name" id="name" type="text" ></b-form-input>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="URL"
                            label-for="url"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input v-model="selectedItem.url" id="url" type="text"></b-form-input>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>
                        
                </div>
            </b-form>

            <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="registerDevice()" v-show="this.selectedItem.id"><i class="fa fa-handshake-o"></i><span>Registrar dispositivo</span></b-button>
            
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Dispositivo</span></b-button>
        
        </div>

        </b-card>
      </b-modal>

      
      <b-modal
              v-model="scheduleStopModal"
              id="schedule-stop-modal"
              centered
              hide-footer
              title="Parada Programada"
              size="md">
  
        <b-card>
          <b-form @submit.stop.prevent="onSubmit">
  
              <div class="animated fadeIn">
          
                  <b-row>
                      <b-col md="12">
                      <b-form>
                          <b-form-group
                          description=""
                          label="Início"
                          label-for="scheduleStopStart"
                          :label-cols="3"
                          :horizontal="true">
                          <date-picker v-model="scheduleStopStart" :config="datePickerOptions"></date-picker>
                      </b-form-group>          
                      </b-form>
                      </b-col>
                  </b-row>

                  <b-row>
                      <b-col md="12">
                      <b-form>
                          <b-form-group
                          description=""
                          label="Término"
                          label-for="scheduleStopEnd"
                          :label-cols="3"
                          :horizontal="true">
                          <date-picker v-model="scheduleStopEnd" :config="datePickerOptions"></date-picker>
                      </b-form-group>          
                      </b-form>
                      </b-col>
                  </b-row>


              </div>
            </b-form>

            <div slot="footer" class="text-right">
              <b-button variant="html5" class="mr-1 btn-brand" @click="removeScheduleStop()"><i class="fa fa-check"></i><span>Remover Parada</span></b-button>
              <b-button variant="github" class="mr-1 btn-brand" @click="startScheduleStop()"><i class="fa fa-check"></i><span>Iniciar Parada</span></b-button>
            </div>

          </b-card>
      </b-modal>

  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'

  
  /* DataTimePicker */
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: '', licensedUntil: null}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      datePicker
    },
    data: () => {
      return {

        scheduleStopStart: null,
        scheduleStopEnd: null,
        datePickerOptions: {
            format: 'DD/MM/YYYY HH:mm',
            useCurrent: false,
        },
        scheduleStopModal: false,
      
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
      
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
       editModal: false,
        filters: {
          key: '',
          status: 'A'
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          {key: 'code', label: 'Código', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          {key: 'name', label: 'Ambiente', sortable: true },
          {key: 'scheduleStopStart', label: 'Parada programada', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          {key: 'scheduleStopEnd', label: 'Término da parada', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          {key: 'st', label: 'Ativo', sortable: true, thStyle: { width: "40px" }, class: 'text-center' },
          
          { key: 'action', label: 'Ações', sortable: false, thStyle: { width: "60px" } , class: 'text-center'}
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.name, this.filters.key)

                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )    
          
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },

      async removeScheduleStop() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.delete(
            this.$store.state.ws_url + "/mdfe/environment/schedule?id=" + s.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function (resp) {
            s.refreshData()
        }
        ).catch(function (error) {
            console.log(error)
        });
        
      },

      async startScheduleStop() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        if(!this.scheduleStopStart || !this.scheduleStopEnd) {
          toast ({
                type: VueNotifications.types.error,
                title: 'Parada Programda',
                message: 'Preencha as datas de Início e Término de para e tente novamente.',
                timeout: 5000
            })      
        }
        else {

          var postData = {
            id: this.selectedItem.id,
            scheduleStopStart: this.$utils.stringToDate(this.scheduleStopStart),
            scheduleStopEnd: this.$utils.stringToDate(this.scheduleStopEnd),
            uid: currentUser.id,
            sid: currentUser.sid
          }
          
          await axios.post(
              this.$store.state.ws_url + "/mdfe/environment/schedule",
              postData
          ).then(function (resp) {
              s.refreshData()
          }
          ).catch(function (error) {
              console.log(error)
          });
      
        }
      },
     
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },
  
      async saveItem(currentItem) {
  
        var s = this;
        var postData = {...currentItem};
  
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid
  
        await axios.post(
            this.$store.state.ws_url + "/mdfe/environment",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
  
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
  
    },
  
    save() {
  
        let msgError = [];
  
        if(!this.selectedItem.code || this.selectedItem.code.length < 1)
            msgError.push("Código");
        
        if(!this.selectedItem.name || this.selectedItem.name.length < 1)
            msgError.push("Ambiente");
        
        if(!this.selectedItem.url || this.selectedItem.url.length <= 2)
            msgError.push("URL");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )
  
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },
  
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
     
      closeEditModal() {
        this.editModal = false;
      },

      openScheduleStop(item) {
        this.selectedItem = { ...item };
        this.scheduleStopModal = true
      },

      closeScheduleStop() {
        this.scheduleStopModal = false
      },

      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      async refreshData() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/mdfe/environment?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.items = resp.data.obj;
          }
          ).catch(function (error) {
              console.log("ERRO")
              console.log(error.message);
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Erro',
                  message: 'Sem permissão de acesso. Verifique e tente novamente.',
                  timeout: 3000
              })
          });

          this.isBusy = false;
      
      },
      changeCompany() {
        this.refreshData();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.changeCompany()
      
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>